import ja from 'date-fns/locale/ja';
import { registerLocale } from 'react-datepicker';

type IUseConfigReactDatepicker = () => void;

export const useConfigReactDatepicker: IUseConfigReactDatepicker = () => {
  registerLocale('ja', ja);
};
